import React, { Component } from 'react';

class PhoneNumberCountryItem extends Component {

    constructor() {

        super();
        this.onRemove = this.onRemove.bind(this);
    }

    onRemove() {

        return this.props.onRemove(this.props.code);
    }

    render() {

        return (
            <li className="list-group-item">
                <div className="row">
                    <div className="col-6">
                        {this.props.code}
                    </div>
                    <div className="col-6 text-right">
                        <span style={{ cursor: 'pointer' }} onClick={this.onRemove}>
                            <i className="fa fa-times"></i>
                        </span>
                    </div>
                </div>
            </li>
        );
    }
}

class PhoneNumberCountriesPanel extends Component {

    constructor() {

        super();
        this.state = {
            newCountry: ''
        };
        this.onNewCountryKeyed = this.onNewCountryKeyed.bind(this);
        this.onNewCountryPossiblySubmitted = this.onNewCountryPossiblySubmitted.bind(this);
    }

    onNewCountryKeyed(e) {

        this.setState({ newCountry: e.target.value.toUpperCase() });
    }

    onNewCountryPossiblySubmitted(e) {

        if (e.key === 'Enter') {
            const code = this.state.newCountry.trim();
            if (code) {
                this.props.onAdd(code);
                this.setState({ newCountry: '' });
            }
        }
    }

    render() {

        return (
            <div className="row" style={{ marginTop: '0.5rem' }}>
                <div className="col-12">
                    <span className="text-left" style={{ fontSize: '0.85rem' }}>
                        <strong>Phone Number Countries</strong>
                    </span>
                    <ul className="list-group" style={{ marginTop: '0.25rem' }}>
                        {
                            this.props.countries.map((code) => {

                                return <PhoneNumberCountryItem key={code} code={code} onRemove={this.props.onRemove} />;
                            })
                        }
                        <li className="list-group-item">
                            <style dangerouslySetInnerHTML={{__html: `
                                .no-lines:focus {
                                    outline: none;
                                    border-color: inherit;
                                    -webkit-box-shadow: none;
                                    box-shadow: none;
                                }
                            `}}>
                            </style>
                            <input
                                type="text"
                                value={this.state.newCountry}
                                className="form-control no-lines"
                                style={{ border: 'none' }}
                                placeholder="Add ISO country code (e.g. US)"
                                onChange={this.onNewCountryKeyed}
                                onKeyPress={this.onNewCountryPossiblySubmitted}
                            />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default PhoneNumberCountriesPanel;
